const paymentMethods = [
    { value: "cash", label: "Cash" },
    { value: "creditCard", label: "Credit Card" },
    { value: "annulment", label: "Annulment", restricted: true },
    { value: "zelle", label: "Zelle" },
];

export default paymentMethods;
